import React, { useState } from 'react';
import { Button, Modal, Col, Form, Row } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { useFirebase } from '../../../contexts/FirebaseContext';

const DeleteSession = ({ track }) => {
  const [showDeleteSession, setShowDeleteSession] = useState(false);
  const { deleteSession } = useFirebase();

  const { register, reset, handleSubmit } = useForm();

  const onSubmit = async (data) => {
    await deleteSession(track, data.session)
      .then(reset())
      .then(() => {
        toast.success(`${data.session} has been deleted!`, {
          duration: 2000,
          icon: '👏',
        });
      })
      .then(
        setTimeout(() => {
          window.location.reload();
        }, 2000)
      )
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          className='btn-danger ml-2 mt-2 mb-2'
          onClick={() => setShowDeleteSession(true)}
        >
          Delete Session
        </Button>
      </div>

      <Modal
        size='md'
        data-backdrop='static'
        data-keyboard='false'
        animation={true}
        show={showDeleteSession}
        onHide={() => setShowDeleteSession(!showDeleteSession)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Session</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                {/* Session */}
                <Form.Label>Session</Form.Label>
                <Form.Group controlId='formDeleteSession'>
                  <Form.Control
                    type='text'
                    name='session'
                    placeholder='What session?'
                    ref={register({ required: true })}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button className='w-25' variant='danger' type='submit'>
                  Delete
                </Button>
                <Toaster />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DeleteSession;
